import React, { useState } from "react";
import { Box, Typography, Paper, Alert } from "@mui/material";
import axios from "axios";
import AxiosInstance from "../utils/Axios.ts";
import DynamicTab from "../components/extras/DynamicTab.tsx";
import { useAuth } from "../context/AuthContext.tsx";
import { useNavigate } from "react-router-dom";
import TextInput from "../components/basics/TextInput.tsx";
import Button from "../components/basics/Button.tsx";

function loginErrorMessage(error: unknown): string {
    if (axios.isAxiosError(error)) {
        if (!error.response) {
            return "Cannot reach the server. Check your connection and API address.";
        }
        const status = error.response.status;
        if (status === 401) {
            return "Invalid username or password.";
        }
        if (status === 404) {
            return "Login service was not found. Check that the API base URL includes the /live path.";
        }
        if (status >= 500) {
            return "The server had a problem. Please try again later.";
        }
    }
    return "Login failed. Please try again.";
}

const LoginPage = () => {
    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setErrorMessage(null);
        try {
            const body = JSON.stringify({ username, password });
            const response = await AxiosInstance.post("/token/", body);

            const { access, refresh } = response.data;
            if (access && refresh) {
                localStorage.setItem("access", access);
                localStorage.setItem("refresh", refresh);
                login(access);
                navigate("/");
            } else {
                setErrorMessage("The server response was missing tokens. Please contact support.");
            }
        } catch (error) {
            console.error("Login failed", error);
            setErrorMessage(loginErrorMessage(error));
        }
    };


    return (
        <DynamicTab title="IT Master" favicon="/logos/IT logo.png">
        <Box
        sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh"
        }}
        >
        <Paper
            elevation={3}
            sx={{
            padding: "2rem",
            maxWidth: "400px",
            width: "100%",
            textAlign: "center",
            }}
        >
            <Typography variant="h4" component="h1" gutterBottom>
            Login
            </Typography>
            {errorMessage && (
                <Alert severity="error" sx={{ mb: 2, textAlign: "left" }}>
                    {errorMessage}
                </Alert>
            )}
            <form onSubmit={handleSubmit}>
            <Box sx={{ marginBottom: "1rem" }}>
                <TextInput
                label="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                />
            </Box>
            <Box sx={{ marginBottom: "1rem" }}>
                <TextInput
                label="Password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                />
            </Box>
            <Button type="submit" text="Login" />
            </form>
        </Paper>
        </Box>
        </DynamicTab>
    );
};

export default LoginPage;


